<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">{{newCompanyGroup ? 'Add Company Group' : 'Edit Company Group'}}</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body" style="max-height: 70vh; overflow-y: auto;">
  <form [formGroup]="companyGroupDetails" autocomplete="off">

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Name</label>
        <input class="form-control" placeholder="Name" maxlength="75" formControlName="name"
              [class.is-invalid]="companyGroupDetails.controls['name'].invalid && companyGroupDetails.controls['name'].touched">
        <div class="invalid-feedback">Name is required.</div>
        <div class="form-text text-end">{{companyGroupDetails.controls['name'].value?.length || 0}}/75</div>
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Additional Information</label>
        <textarea class="form-control" placeholder="Information" maxlength="250" formControlName="information" rows="3"></textarea>
        <div class="form-text text-end">{{companyGroupDetails.controls['information'].value?.length || 0}}/250</div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Admin Email Address</label>
        <input class="form-control" placeholder="Email Address" maxlength="50" formControlName="adminEmailAddress"
              [class.is-invalid]="companyGroupDetails.controls['adminEmailAddress'].invalid && companyGroupDetails.controls['adminEmailAddress'].touched">
        <div class="invalid-feedback">Please enter a valid email address.</div>
        <div class="form-text text-end">{{companyGroupDetails.controls['adminEmailAddress'].value?.length || 0}}/50</div>
      </div>

      <div class="col-sm-6">
        <label class="form-label fw-semibold">Manager Email Address</label>
        <input class="form-control" placeholder="Email Address" maxlength="50" formControlName="managerEmailAddress"
              [class.is-invalid]="companyGroupDetails.controls['managerEmailAddress'].invalid && companyGroupDetails.controls['managerEmailAddress'].touched">
        <div class="invalid-feedback">Please enter a valid email address.</div>
        <div class="form-text text-end">{{companyGroupDetails.controls['managerEmailAddress'].value?.length || 0}}/50</div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Equity Release Fee</label>
        <div class="input-group">
          <span class="input-group-text">£</span>
          <input class="form-control" placeholder="Equity Release Fee" formControlName="equityReleaseFee" type="number">
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-4">
        <label class="form-label fw-semibold">Bank Account Name</label>
        <input class="form-control" placeholder="Account Name" maxlength="100" formControlName="accountName">
      </div>
      <div class="col-sm-4">
        <label class="form-label fw-semibold">Bank Account Number</label>
        <input class="form-control" placeholder="Account Number" maxlength="20" formControlName="accountNumber">
      </div>
      <div class="col-sm-4">
        <label class="form-label fw-semibold">Bank Sort Code</label>
        <input class="form-control" placeholder="Sort Code" maxlength="8" formControlName="sortCode">
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Restrict FA Access and Emails</label>
        <app-yes-no-form-toggle class="d-block" formControlName="noAccessOrUpdatesForFAs" (change)="checkRestrictFAValue()"></app-yes-no-form-toggle>
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Has API Access</label>
        <app-yes-no-form-toggle class="d-block" formControlName="apiAccess"></app-yes-no-form-toggle>
      </div>
    </div>

    <ng-container *ngIf="companyGroupDetails.controls['apiAccess'].value">
      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">API Client ID</label>
          <input class="form-control" placeholder="Client ID" formControlName="apiClientId">
        </div>
        <div class="col-sm-6">
          <label class="form-label fw-semibold">API Client Secret</label>
          <input class="form-control" placeholder="Client Secret" formControlName="apiClientSecret">
        </div>
      </div>
    </ng-container>

    <div class="row mb-3"  *ngIf="!newCompanyGroup">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Active</label>
        <app-yes-no-form-toggle class="d-block" formControlName="active"></app-yes-no-form-toggle>
      </div>
    </div>

  </form>
</div>

<div class="modal-footer">

  <ng-container *ngIf="!newCompanyGroup">
    <button *ngIf="updatingGroup" type="button" class="btn btn-success" disabled>
      <span class="spinner-border spinner-border-sm" role="status"></span>
      Updating...
    </button>
    <button *ngIf="!updatingGroup" type="button" class="btn btn-success" 
        (click)="saveCompanyGroup()" [disabled]="companyGroupDetails.invalid">Update</button>

  </ng-container>

  <ng-container *ngIf="newCompanyGroup">
    <button type="button" class="btn btn-success" 
        (click)="addCompanyGroup()" [disabled]="companyGroupDetails.invalid">Save</button>
  </ng-container>
</div>